import React, { useMemo } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';
import { useCurrencyCodes } from 'hooks/useCurrencyCodes';

const CurrencySelectField = ({
    field,
    data,
    change,
    hasError,
    errorMessage,
    availableCurrencies = [],
}) => {
    const { toDropdownOptions } = useCurrencyCodes();
    const options = useMemo(() => {
        if (field.labelFormat) {
            return toDropdownOptions({ labelFormat: field.labelFormat });
        }
        return availableCurrencies.length ? availableCurrencies : toDropdownOptions();
    }, [field.labelFormat, availableCurrencies, toDropdownOptions]);

    const currentValue = options.find((c) => c.value === data[field.key]) || null;

    return (
        <Autocomplete
            size="small"
            options={options}
            value={currentValue}
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(event, newValue) => {
                change(field.key, newValue ? newValue.value : '');
            }}
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    {option.label}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...outlinedFieldProps}
                    label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
                    placeholder="Select currency"
                    error={hasError}
                    helperText={hasError ? (errorMessage || 'This field is required') : ''}
                />
            )}
        />
    );
};

export default CurrencySelectField;
